// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__MxBPO","input":"index_input__sDDIs","suffix":"index_suffix__8_UOI"};